import Query from './Query'
import { scrollTop } from 'gvue/src/assets/js/utils/assist'

export default {
    methods: {
        goToAnchor () {
            const anchor = Query.get()
            if (!anchor || !this.$el) {
                return
            }
            const anchorId = anchor
            this.$nextTick(() => this.scrollToElement(anchorId))
        },
        scrollToElement (el) {
            const elDom = document.getElementById(el)
            if (elDom) {
                // Here the setTimeout is used to be sure that the dom is rendered with the good offsetTop for the element to reach
                setTimeout(() => scrollTop(window, 0, elDom.offsetTop - 60), 1000)
            }
        }
    }
}
